import axiosInstance from "./axiosInstance";

export const postFirmInvitationApi = (reqBody) =>
  axiosInstance.post(`/api/v1/govt/invite`, reqBody);
